import { createTargetSelector } from '../Redux/utils'

export const getMessagesTarget = createTargetSelector('messages')
export const getLogoutActionTarget = createTargetSelector('logoutAction')
export const getCompaniesTarget = createTargetSelector('companies')
